"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AdvDate_1 = require("./../lib/AdvDate");
var Projection = (function () {
    function Projection() {
        this._asAt = null;
        this._year = 0;
        this._isTwoPersonProjection = false;
        this._enforceMinimumDrawingRequirements = false;
    }
    Projection.prototype.initialise = function (isTwoPersonProjection, enforceMinimumDrawingRequirements) {
        this._asAt = new AdvDate_1.AdvDate();
        this._year = 1;
        this._isTwoPersonProjection = isTwoPersonProjection;
        this._enforceMinimumDrawingRequirements = enforceMinimumDrawingRequirements;
    };
    Projection.prototype.incrementYear = function () {
        this._year++;
    };
    Projection.prototype.isNotFirstYear = function () {
        return this._year !== 1;
    };
    Object.defineProperty(Projection.prototype, "yearCount", {
        get: function () { return this._year; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Projection.prototype, "asAt", {
        get: function () { return this._asAt; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Projection.prototype, "isTwoPersonProjection", {
        get: function () { return this._isTwoPersonProjection; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Projection.prototype, "enforceMinimumDrawingRequirements", {
        get: function () { return this._enforceMinimumDrawingRequirements; },
        enumerable: true,
        configurable: true
    });
    return Projection;
}());
exports.Projection = Projection;
//# sourceMappingURL=Projection.js.map